export default "__VITE_PUBLIC_ASSET__c2f36061__"